import type { Item, Question } from "../../shared/api";

function shuffled(items: Item[] = [], random = Math.random): Item[] {
  const copy = [...items];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  // Match the mini program: avoid accidentally retaining the original order.
  if (copy.length > 1 && copy.every((item, i) => item.id === items[i].id)) {
    copy.push(copy.shift()!);
  }
  return copy;
}

export function prepareQuestion(
  question: Question,
  random = Math.random,
): Question {
  if (!question.settings.shuffle) return question;
  const content = { ...question.content };
  if (question.type === "select-many" || question.type === "order-tap")
    content.items = shuffled(content.items, random);
  if (question.type === "match-pairs") {
    content.leftItems = shuffled(content.leftItems, random);
    content.rightItems = shuffled(content.rightItems, random);
  }
  if (question.type === "matrix-select")
    content.options = shuffled(content.options, random);
  return { ...question, content };
}
